<template>
	<div class="wrapper">
		<div class="content">
			<!-- 轮播图 -->
			<div class="swipe-box" v-if="dataList.bannerslist">
				<!-- <div class="blur" :style="{backgroundImage: 'url(' + imgBack + ')'}"></div> -->
				<div class="my-top">
					<div class="top-icon">
						<img
							style="border-radius:10px;width:40px;height:40px;float:left;margin-top:7px;margin-bottom:5px;background-color:#fff;"
							src="../assets/img/lodd-little.png"
						/>
						<span><b>首页</b></span>
						<span @click="handleGoNext('nearbyShop')">附近商家</span>
						<span @click="handleGoList">商品</span>
						<span @click="handleGoNext('shopCooperation')">合作</span>
						<!-- <span @click="handleGoNext('videoList')">视频</span> -->
						<img
							style="width:25px;height:25px;border-radius:50%;float:right;margin-top:17px;"
							src="../assets/img/icon/personal.png"
							@click="handleGoNext('userInfo')"
						/>
					</div>
					<div class="top-icon-qx"><img src="../assets/img/icon/qx.png" /></div>
					<div class="search_input">
						<!-- <img style="width:25px;height:25px;border-radius:50%;float:right;margin-top:7px;margin-bottom:5px;" src="../assets/img/icon/personal.png" @click="handleGoNext('userInfo')"> -->
						<!-- <img style="width:25px;height:25px;float:right;margin-top:7px;margin-right:10px;margin-bottom:5px;" src="../assets/img/icon/cart-64.png" @click="handleGoNext('cart')"> -->
						<i class="fa fa-search" id="i-advanced-search-i"><img style="width: 15px;height: 15px;" src="../assets/img/icon/fdj-01.png" /></i>
						<input type="text" id="i-advanced-search" @click="handleSearch" placeholder="商品搜索从这里开始" placeholder-class="placeholder" />
					</div>
					<!-- <div class="top-icon">
                        <span><b>首页</b></span>
                        <span @click="handleGoNext('nearbyShop')">附近商家</span>
                        <span @click="handleGoList">全部商品</span>
                        <span @click="handleGoNext('goodsCategory')">分类</span>
                        <span @click="handleGoNext('videoList')">视频</span>
                        <span @click="handleGoNext('goodsCategory')" style="margin-right:1px;">
                            <img style="width:18px;height:18px;" src="../assets/img/icon/cate001.png">
                        </span>
                        <span>    
                            分类
                        </span>
                    </div>
                    <div class="top-icon-qx">
                        <img src="../assets/img/icon/qx.png">
                    </div> -->
					<!-- <van-search v-model="searchKey" placeholder="请输入搜索关键词"  shape="round" background="#00BFFF"  @focus="handleSearch"/> -->
				</div>
				<!-- 搜索 -->
				<!-- <div class="search-box">
                   <van-search v-model="searchKey" placeholder="请输入搜索关键词"  shape="round" background="#00BFFF"  @focus="handleSearch"/>
               </div> -->
				<!-- @change="handleChangeSwipe" -->
				<div class="swier-bg-box">
					<van-swipe :autoplay="3000" class="swier-item" indicator-color="#00BFFF">
						<van-swipe-item v-for="(item, index) in dataList.bannerslist" :key="index" @click="bannerJump(item)">
							<img :src="item.img_url" style="width: 100%;height: 180px;border-radius:10px" class="swipe-img" />
						</van-swipe-item>
					</van-swipe>
				</div>
			</div>

			<!-- 访问量 -->
			<!-- <div class="traffic-volume-box">
                <div>
                    <van-icon name="eye-o" color="#EF000C" size="25" />
                    <span style="margin-left: 5px;">综合访问量</span>
                    <span style="color: #EF000C">{{dataList.visitsnum || 10000}}</span>
                    <span>人</span>
                </div>
               <div>
                   <span class="fwl">访问量</span>
               </div>
            </div> -->

			<!-- 首页公告 -->
			<van-notice-bar
            left-icon="volume-o"
            :text="dataList.notice.title"
            @click="handleGoNows" style="width: 86%;margin-left: auto;margin-right: auto;"
            />

			<!-- 分类导航 -->
			<div class="icon-box" style="margin: 10px;padding: 10px;" v-if="dataList.iconList">
				<div class="icon-item" v-for="item in dataList.iconList" @click="handleGoIcon(item)" :key="item.id">
					<div class="icon-box"><img :src="item.img_url" alt="" /></div>
					<div class="icon-text">{{ item.title }}</div>
				</div>
			</div>

			<!--  广告位-->
			<div class="advertisement-box" @click="handleGoConsultation" v-if="dataList.consultation"><img :src="dataList.consultation.logo" /></div>
			<!-- <div style="width:100%;height:2px;background:#f4f4f4;margin:10px 0;"></div> -->
			<!--新品-->
			<div class="new-box goods-box" v-if="dataList.newProducts.length > 0">
				<div class="title">
					<img @click="handleGoIcon(dataList.home_new_img)" :src="dataList.home_new_img.img_url" />
					<!-- <img src="../assets/img/icon/icon-home-nav.png" alt="" style="height: 50px"> -->
					<!-- <span style="color:#00BFFF;position: absolute;right:47%;font-size:16px">新品</span> -->
				</div>
				<div class="goods-list">
					<div class="goods-item" v-for="item in dataList.newProducts" :key="item.id" @click="handleGoGoodsInfo(item.id)">
						<!-- <div class="tag-box" style="">
                           <div class="txt" >新品</div>
                           <div class="triangle"></div>
                       </div> -->
						<div class="goods-details">
							<img v-lazy="item.logo" class="goods-img" />
							<p class="goods-price">
								<span class="new-price">
									<img class="goods-price-img" src="../assets/img/hb.png" />
									{{ item.hb_num }}
								</span>
							</p>
							<p class="goods-name">{{ item.name }}</p>
						</div>
					</div>
				</div>
				<div class="goods-list">
					<div class="goods-item" v-for="item in dataList.newProducts_two" :key="item.id" @click="handleGoGoodsInfo(item.id)">
						<!-- <div class="tag-box" style="">
                           <div class="txt" >新品</div>
                           <div class="triangle"></div>
                       </div> -->
						<div class="goods-details">
							<img v-lazy="item.logo" class="goods-img" />
							<p class="goods-price">
								<span class="new-price">
									<img class="goods-price-img" src="../assets/img/hb.png" />
									{{ item.hb_num }}
								</span>
							</p>
							<p class="goods-name">{{ item.name }}</p>
						</div>
					</div>
				</div>
			</div>

			<!-- <div style="width:100%;height:2px;background:#f4f4f4;margin:10px 0;"></div> -->

			<!--推荐-->
			<div class="recommend-box goods-box" v-if="dataList.recommend.length > 0">
				<div class="title">
					<img @click="handleGoIcon(dataList.home_tuijian_img)" :src="dataList.home_tuijian_img.img_url" />
					<!-- <img src="../assets/img/icon/icon-home-nav.png" alt="" style="height: 30px">
                   <span style="color:#00BFFF;position: absolute;right:47%;font-size:16px">推荐</span> -->
					<!-- <div class="text" @click="handleGoList">
                       <span>查看全部</span>
                       <van-icon name="arrow" /></div> -->
				</div>
				<div class="goods-list">
					<div class="goods-item" v-for="item in dataList.recommend" :key="item.id" @click="handleGoGoodsInfo(item.id)">
						<div>
							<img v-lazy="item.logo" class="goods-img" />
							<p class="goods-name">{{ item.name }}</p>
							<p class="goods-price">
								<span class="new-price">
									<img class="goods-price-img" src="../assets/img/hb.png" />
									{{ item.hb_num }}
								</span>
								<s class="old-price" v-if="item.high_price > 0">
									<img class="goods-price-img" src="../assets/img/hb.png" />
									{{ item.high_price }}
								</s>
							</p>
						</div>
					</div>
				</div>
			</div>

			<!-- 特卖 -->
			<div class="special-box goods-box recommend-box " v-if="dataList.specialOffer.length > 0">
				<div class="title">
					<img @click="handleGoIcon(dataList.home_tejia_img)" :src="dataList.home_tejia_img.img_url" />
					<!-- <img src="../assets/img/icon/icon-home-nav.png" alt="" style="height: 30px">
                   <span style="color:#00BFFF;position: absolute;right:47%;">特卖</span> -->
				</div>
				<div class="goods-list">
					<div class="goods-item" v-for="item in dataList.specialOffer" :key="item.id" @click="handleGoGoodsInfo(item.id)">
						<div>
							<img v-lazy="item.logo" class="goods-img" />
							<p class="goods-name">{{ item.name }}</p>
							<p class="goods-price">
								<span class="new-price">￥{{ item.hb_num }}</span>
								<s class="old-price" v-if="item.high_price > 0">￥{{ item.high_price }}</s>
							</p>
						</div>
					</div>
				</div>
			</div>

			<!-- 热卖 -->
			<!--           <div class="hot-box goods-box recommend-box" v-if=" dataList.hotSale.length > 0">-->
			<!--               <div class="title">-->
			<!--                   <img src="../assets/img/icon/re.png" alt="" style="height: 22px">-->
			<!--               </div>-->
			<!--               <div class="goods-list">-->
			<!--                       <div class="goods-item" v-for="item in dataList.hotSale" :key="item.id" @click="handleGoGoodsInfo(item.id)">-->
			<!--                           <div>-->
			<!--                               <img v-lazy="item.logo" class="goods-img"/>-->
			<!--                               <p class="goods-name">{{item.name}}</p>-->
			<!--                               <p class="goods-price">-->
			<!--                                   <span class="new-price">-->
			<!--                                       ￥{{item.hb_num}}-->
			<!--                                   </span>-->
			<!--                                   <br>-->
			<!--                                   <s class="old-price" v-if="item.high_price > 0">-->
			<!--                                       ￥{{item.high_price}}-->
			<!--                                   </s>-->
			<!--                               </p>-->
			<!--                           </div>-->

			<!--                       </div>-->
			<!--               </div>-->
			<!--           </div>-->

			<!-- 保障 -->
			<!--           <div class="guarantee-box goods-box recommend-box" v-if="dataList.specialOffer.length > 0">-->
			<!--               <div class="title">-->
			<!--                   <img src="../assets/img/icon/bao.png" alt="" style="height: 22px">-->
			<!--               </div>-->
			<!--               <div class="goods-list">-->
			<!--                       <div class="goods-item" v-for="item in dataList.specialOffer" :key="item.id" @click="handleGoGoodsInfo(item.id)">-->
			<!--                           <div>-->
			<!--                               <img v-lazy="item.logo" class="goods-img"/>-->
			<!--                               <p class="goods-name">{{item.name}}</p>-->
			<!--                               <p class="goods-price">-->
			<!--                                   <span class="new-price">-->
			<!--                                       ￥{{item.hb_num}}-->
			<!--                                   </span>-->
			<!--                                   <br>-->
			<!--                                   <s class="old-price" v-if="item.high_price > 0">-->
			<!--                                       ￥{{item.high_price}}-->
			<!--                                   </s>-->
			<!--                               </p>-->
			<!--                           </div>-->

			<!--                       </div>-->
			<!--               </div>-->
			<!--               <div class="empty" @click="handleGoList">-->
			<!--                   点击查看更多-->
			<!--               </div>-->
			<!--           </div>-->
			<div class="guarantee-box goods-box recommend-box"><div class="empty" @click="handleGoList">点击查看更多</div></div>
			<div class="xy-box">
				客服电话 ：<a href="tel:4000567831">4000567831</a>
			</div>
			<div class="xy-box">
				微信(电话) ：<a href="tel:13522618284">13522618284</a>
				<p style="color: #666666;font-size: 12px;margin-top: 10px;">联系我时，请说是在“收到乐”公众号上看到的，谢谢！</p>
			</div>
			<div style="width: 100%;text-align: center;margin-top: 8px;">
				<a href="https://beian.miit.gov.cn/" style="color: #999;">京ICP备19056392号</a>
			</div>
		</div>
		<!--       <div class="footer">
		<!--           <BaseFooterBar :active="1"/>-->
		<!--       </div>-->
		<footer><TheFooterBar :active="1" /></footer>
	</div>
</template>

<script>
import TheFooterBar from '../components/base/TheFooterBar';
import { getBannersListService, getNewGoodsService, getRecommendGoodsService, getHomeService } from '../service/goodsService';
import { getConsultationServive, getConsultationDetailsServive, getVisitsnumService } from '../service/untilService';
import { Toast, Dialog } from 'vant';
import Cookies from 'js-cookie'; // 缓存
import { getUrlParamsTools } from '../util/tools';
import { doUserShareService } from '../service/basicService';
import { mapState } from 'vuex';
	//import {wecharShare} from "../util/weChat.js";
export default {
	data() {
		return {
			searchKey: '', //搜索关键字
			// swipeList:[],//轮播图列表
			imgBack: null,
			// iconList:[],//图标列表
			// advertisement:'',//咨询信息
			// newGoods:[],//新品推荐列表
			recommendGoodsList: [], //推荐商品
			dataList: {} //首页信息
			// visitsNum:0,//访问量
			// loading: false,
			// finished: false,
			// offset:{
			//     page:1,
			//     limit:10,
			// },
		};
	},
	mounted() {
		//获取首页数据
		this.getHome();
		//wecharShare(location.href.split('#')[0],location.href.split('#')[1]);
	},
	created() {
		this.shareOpenId = getUrlParamsTools('openid');
		if (this.shareOpenId != null) {
			this.doUserShare(this.shareOpenId);
		}
	},
	activated() {
		console.log('页面显示');
		console.log('home-user-id', this.userId);
		const is_xy = Cookies.get('is_xy');
		// 用户同意协议
		if (!is_xy) {
			Dialog.confirm({
				confirmButtonColor: '#00BFFF',
				title: '服务协议和隐私政策',
				confirmButtonText: '同意',
				cancelButtonText: '暂不使用',
				closeOnClickOverlay: true,
				message:
					'请你务必审慎阅读、充分理解“服务协议”和“隐私政策”各条款，包括但不限于：为了向你提供良好的用户体验，我们需要收集你的设备信息，操作日志等个人信息。你可阅读“<a href="https://www.shoudaole.cn/dist/#/fuwuxieyi">《服务协议》”</a>和“<a target="_blank" href="https://www.shoudaole.cn/dist/#/yinsizhengce">《隐私政策》</a>”了解详细信息。如你同意，请点击“同意”开始接受我们的服务。'
			})
				.then(() => {
					Cookies.set('is_xy', 1);
				})
				.catch(() => {
					// Cookies.set('is_xy', 0);
				});
		}
	},
	deactivated() {
		console.log('页面隐藏');
		Dialog.close();
	},
	methods: {
		doUserShare(shareOpenId) {
			// 记录分享人openid
			doUserShareService(shareOpenId, this.openId)
				.then(res => {
					if (res.status === 1) {
						console.log('已记录分享人');
					} else {
						Toast(res.msg);
					}
				})
				.catch(err => {
					console.log(err);
				});
		},
		handleGoNows() {
			console.log(this.dataList.notice.id);

			this.$router.push({
				name: 'nows',
				params: {
					id: this.dataList.notice.id
				}
			});
		},

		//搜索
		handleSearch() {
			this.$router.push({
				name: 'search'
			});
		},

		//跳转链接
		handleGoIcon(item) {
			console.log(item);
			if (item.jump_type == 1) {
				window.location.href = item.param;
			} else {
				if (item.param.wechat == 'goodsMuster') {
					this.$router.push({
						name: 'goodsMuster',
						params: {
							typeId: 0,
							searchKey: '-1'
						}
					});
				} else if (item.param.wechat == 'nows') {
					const id = item.param.ios;
					this.$router.push({
						name: 'nows',
						params: {
							id: id
						}
					});
				} else if (item.param.wechat == 'offer') {
					this.$router.push({
						name: 'offer',
						params: {
							typeId: 0
						}
					});
				} else {
					this.$router.push({
						name: item.param.wechat
					});
				}
				// else if (item.param.wechat == 'luck') {
				// 	if (this.userId === null) {
				// 		Toast('请您先登录');
				// 		this.$router.push({
				// 			name: 'userLogin'
				// 		});
				// 	} else {
				// 		window.location.href = 'https://www.shoudaole.cn/luck/?uid=' + this.userId +'&timestamp='+ new Date().getTime();
				// 	}
				// }
			}
		},
		// banner跳转
		bannerJump(item) {
			if (item.jump_type == 1) {
				window.location.href = item.param;
			} else {
				if (item.param.wechat == 'goodsMuster') {
					this.$router.push({
						name: 'goodsMuster',
						params: {
							typeId: 0,
							searchKey: '-1'
						}
					});
				} else if (item.param.wechat == 'nows') {
					const id = item.param.ios;
					this.$router.push({
						name: 'nows',
						params: {
							id: id
						}
					});
				} else {
					this.$router.push({
						name: item.param.wechat
					});
				}
			}
		},

		//首页轮播图模糊效果
		// handleChangeSwipe(index){
		//     console.log(this.dataList.bannerslist[index])
		//     this.imgBack = this.dataList.bannerslist[index].img_url;

		// },

		//查询咨询详情
		handleGoConsultation() {
			this.$router.push({
				name: 'baseConsultation',
				params: {
					id: this.advertisement.id
				}
			});
		},

		//获取新品商品信息
		getNewGoods() {
			getNewGoodsService()
				.then(res => {
					if (res.status === 1) {
						this.newGoods = res.datas;
					} else {
						Toast(res.msg);
					}
				})
				.catch(err => {
					console.log(err);
				});
		},

		//查询所有商品
		handleGoList() {
			this.$router.push({
				name: 'goodsMuster',
				params: {
					typeId: 0,
					searchKey: '-1'
				}
			});
			// this.$router.push({
			//     name:'goodsMuster',
			//     params:{
			//         typeId:0,
			//         searchKey:-1,
			//     }
			// })
		},

		//跳转页面(无参数)
		handleGoNext(param) {
			console.log(param);
			this.$router.push({
				name: param
			});
		},
		//跳转商品详情
		handleGoGoodsInfo(goodsId) {
			this.$router.push({
				name: 'goodsDetails',
				params: {
					goodsId
				}
			});
		},

		//获取首页信息
		getHome() {
			getHomeService(1)
				.then(res => {
					if (res.status === 1) {
						this.dataList = res.datas;
						this.handleChangeSwipe(0);
					} else {
						Toast(res.msg);
					}
				})
				.catch(err => {
					console.log(err);
				});
		}
	},
	components: {
		// BaseFooterBar,
		TheFooterBar
	},
	computed: {
		...mapState({
			openId: state => state.userInfo.openId,
			userId: state => state.userInfo.userId
		})
	}
};
</script>

<style scoped lang="scss">
.xy-box {
	margin-top: 10px;
	text-align: center;
	width: 100%;
	color: #ef000c;
	font-weight: bold;
	font-size: 16px;
}
.xy-box a {
	color: #de3328;
}
.wrapper {
	background: #f7f7f7 !important;
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	overflow: hidden;
	overflow-y: auto;
	-webkit-scrollbar: 0px;
	.search_input {
		// margin-left:5%;
		margin-bottom: 10px;
	}
	.search_input input[type='text'] {
		display: inline-block;
		width: 90%;
		border-radius: 15px;
		height: 28px;
		text-indent: 28px;
		line-height: 28px;
		border: none;
		margin-top: 5px;
		margin-left: 5%;
	}

	input::-webkit-input-placeholder {
		/* WebKit browsers */
		color: #cccccc;
		padding-left: 15px;
	}

	// .search_input input[type='text']:focus{
	//     border: 0px;
	//     border-color: white;
	// }

	// .search_input span{
	//     color: white;
	//     font-size: 16px;
	//     display: inline-block;
	//     // width: 55px;
	//     float: left;
	//     letter-spacing:1px;
	//     margin-right: 15px;
	//     height:100%;
	//     line-height:100%;
	// }
	.search_input i {
		position: relative;
		left: -265px; // 这里更改图标的位置
		top: 63px;
		// color: #B2B2B2;//这里可以更改图标的颜色
	}
	.top-icon {
		width: 90%;
		margin-left: 5%;
	}
	.top-icon span {
		color: white;
		font-size: 16px;
		display: block;
		// width: 55px;
		float: left;
		letter-spacing: 1px;
		margin-left: 15px;
		height: 100%;
		line-height: 100%;
		margin-top: 20px;
	}
	.top-icon-qx {
		float: left;
		width: 90%;
		margin-left: 72px;
		margin-top: -10px;
		height: 8px;
		padding-left: 10px;
	}
	.content {
		background: #f7f7f7 !important;
		padding-bottom: 90px;
		.swipe-box {
			position: relative;
			overflow: hidden;
			// .blur{
			//     position: absolute;
			//     top: 0;
			//     height: 99%;
			//     width: 100%;
			//     background-size: 100% 100%;
			//     filter: blur(6px);
			// }
			.search-box {
				box-sizing: border-box;
				background-color: #ffffff;
			}
			.swier-bg-box {
				height: 180px;
				position: relative;
				background-image: url('../assets/img/bg/home-banner.png');
				background-repeat: no-repeat;
				margin-top: -1px;
				background-size: 100%;
				// background-size:100% 100%;
				// -moz-background-size:100% 100%;
				// background-image: linear-gradient(0deg,#fff,#C6251A 100%);
				// border-bottom-left-radius:100%;
				// border-bottom-right-radius:100%;
			}
			.my-top {
				height: 100px;
				background-image: linear-gradient(0deg, #c6251a, #c6251a 100%);
				padding-top: 10px;
			}
		}
		.traffic-volume-box {
			margin-top: 5px;
			padding: 0 12px;
			box-sizing: border-box;
			display: flex;
			align-items: center;
			justify-content: space-between;
			div {
				display: flex;
				align-items: center;
			}
			.fwl {
				display: inline-block;
				border-radius: 2px;
				border: 1px solid rgba(239, 0, 12, 1);
				padding: 2px 4px;
				box-sizing: border-box;
				color: #ef000c;
				margin: 0 10px;
			}
		}
		.icon-box {
			background: #ffffff !important;
			border-radius: 10px;
			box-sizing: border-box;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-wrap: wrap;
			margin: 3px;
			.icon-item {
				flex: 20%;
				margin-top:8px;
				margin-bottom:8px;
				text-align: center;
				img {
					width: 40px;
					height: 40px;
					border-radius: 10px;
				}
				.icon-text {
					font-size: 12px;
					color: #202020;
					margin-top:5px;
					margin-bottom:5px;
				}
			}
		}
		.advertisement-box {
			padding: 0 12px;
			box-sizing: border-box;
			margin-top: 10px;
			img {
				width: 100%;
				height: 84px;
				border-radius: 50px;
			}
		}
		.goods-box {
			padding: 0 12px;
			// box-sizing: border-box;
			.title {
				display: flex;
				align-items: center;
				justify-content: center;
				position: relative;
				img {
					height: 100px !important;
					width: 100%;
					border-radius: 10px;
				}
				.text {
					position: absolute;
					right: 0;
					bottom: 0;
					color: #999999;
					display: flex;
					align-items: center;
				}
			}
		}
		.new-box {
			margin-top: 15px;
			// background-color: #F6F6F6;
			.goods-list {
				margin-top: 5px;
				// margin: 18px 0 10px 0;
				display: flex;
				overflow-x: scroll;
				.goods-item {
					// padding: 0 5px;
					margin-right: 5px;
					padding-right: 5px;
					// box-sizing: border-box;
					position: relative;
					// box-shadow: 1px 1px 1px #ccc;

					.txt {
						padding-top: 5px;
						background-color: #00BFFF;
						display: flex;
						align-items: center;
					}
					.tag-box {
						position: absolute;
						left: 20%;
						top: 0;
						color: #ffffff;
						-webkit-writing-mode: vertical-rl;
						writing-mode: vertical-rl;
						display: flex;
						.triangle {
							border-style: solid;
							border-width: 10px;
							border-top-color: #00BFFF;
							border-left-color: #00BFFF;
							border-bottom-color: transparent;
							border-right-color: #00BFFF;
						}
					}
					.goods-details {
						background: #ffffff;
						font-size: 14px;
						margin-right: 10px;
						img {
							width: 105px;
							height: 105px;
							border-radius: 5px;
						}
						.goods-price {
							display: inline-block;
							height: 16px;
							font-size: 16px;
							color: #ef000c;
							text-align: left;
							// line-height: 16px;
							overflow: hidden;
						}
						.goods-price-img {
							width: 14px;
							height: 14px;
						}
						.goods-name {
							font-size: 12px !important;
							text-align: left;
							color: #666;
							margin-top: 5px;
							text-overflow: -o-ellipsis-lastline;
							overflow: hidden;
							text-overflow: ellipsis;
							display: -webkit-box;
							-webkit-line-clamp: 2;
							line-clamp: 2;
							-webkit-box-orient: vertical;
							height: 30px;
						}
					}
				}
			}
		}
		.recommend-box {
			padding-top: 3px;
			// background: #F6F6F6;
			.goods-list {
				margin-top: 10px;
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				justify-content: space-around;
				.goods-item {
					border-radius: 5px;
					width: 47%;
					padding-bottom: 5px;
					// box-sizing: border-box;
					margin-bottom: 10px;
					// box-shadow: 1px 1px 1px #ccc, -1px -1px 1px #ccc;

					// &:nth-child(2n){
					//     margin-left: 7px;
					// }
					// &:nth-child(2n + 1){
					//     margin-right: 7px;
					// }
					div {
						background: #ffffff;
						border-radius: 5px;
						// border-top-left-radius: 5px;
						// border-top-right-radius: 5px;
						font-size: 12px;
						.goods-img {
							border-top-left-radius: 5px;
							border-top-right-radius: 5px;
							// box-sizing: border-box;
							width: 100%;
							height: 156px;
						}
						.goods-name {
							font-size: 12px !important;
							color: #666;
							margin-top: 10px;
							text-overflow: -o-ellipsis-lastline;
							overflow: hidden;
							text-overflow: ellipsis;
							display: -webkit-box;
							-webkit-line-clamp: 2;
							line-clamp: 2;
							-webkit-box-orient: vertical;
							height: 35px;
						}
						.goods-price {
							display: block;
							margin-top: 6px;
							height: 20px;
							// line-height: 20px;
							border-radius: 10px;
							// display: flex;
							// align-items: center;
							// justify-content: space-between;
							// padding: 0 8px;
							// box-sizing: border-box;
							.new-price {
								display: flex;
								align-items: center;
								font-weight: bold;
								color: #ef000c;
								font-size: 15px;
							}
							.old-price {
								color: #d0d0d0;
								margin-left: 5px;
								font-size: 13px;
							}
						}
						.goods-price-img {
							width: 16px;
							height: 16px;
							margin-right: 3px;
						}
						p {
							padding: 0 12px;
							box-sizing: border-box;
						}
					}
				}
			}
			.empty {
				text-align: center;
			}
		}
	}
}
</style>
<style>
.recommend-box .van-list__finished-text {
	display: none !important;
}
.swipe-box .van-search__content {
	background-color: #ffffff !important;
	z-index: 99;
}
</style>
<style>
.van-swipe-item {
	padding: 0 10px;
	box-sizing: border-box;
}
</style>
